
import { Component, Watch, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import CountDown from '@/components/countdown/index.vue';
import { dateTimeFormatter, readCookie } from '@/tools/tools';
import {
  refundingList, refundList, refundDetail, getDataRefund, getRefundSearch
} from '@/services/http';

@Component({
  components: {
    Header,
    Price,
    Footer,
    CountDown,
    NavMenu
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    }
  }
})
export default class extends Vue {
  editableTabsValue: string = '0'

  editableTabs: any[] = [
    {
      title: '处理中',
      name: '0',
      content: 'Tab 1 content'
    },
    {
      title: '申请记录',
      name: '1',
      content: 'Tab 2 content'
    }
  ]

  options: any[] = [
    {
      value: '1',
      label: '最近一个月'
    },
    {
      value: '2',
      label: '最近三个月'
    },
    {
      value: '3',
      label: '三个月以前'
    }
  ]

  statusOptions: any[] = [
    {
      value: '',
      label: '全部状态'
    },
    {
      value: '1',
      label: '处理中'
    },
    {
      value: '2',
      label: '已完成'
    },
    {
      value: '3',
      label: '已取消'
    },
    {
      value: '4',
      label: '申请失败'
    }
  ]

  value: string = '1'

  statusValue: string = ''

  orderList: any[] = [] // 订单列表

  // page: number = 1

  status: string = ''

  // 当前页数
  currentpage: number = 1

  // 有无数据
  isNodata: boolean = false

  // 总条数
  totalnumber: number = 10

  pageNo: number = 1

  pageSize: number = 10

  docmHeight: any =
    document.documentElement.clientHeight || document.body.clientHeight;

  //  是否固定底部
  isFixed: boolean = false;

  loading: boolean = false;

  // 关键字查询
  keyword: string = ''

  activated() {
    this.getOrderList();
  }

  // mounted() {
  //   const menuHeight = (this as any).$refs.menucont.offsetHeight;
  //   this.isFixed = menuHeight < this.docmHeight - 200;
  // }

  @Watch('value')
  private onTimeChange() {
    this.getOrderList();
  }

  @Watch('statusValue')
  private onStatusChange() {
    this.getOrderList();
  }

  handleClick() {
    this.pageNo = 1;
    this.pageSize = 10;
    this.currentpage = 1;
    this.orderList = [];
    this.getOrderList();
  }

  // 订单列表
  private async getOrderList() {
    const anchor = readCookie('anchor');
    this.orderList = [];
    const url = this.editableTabsValue === '0' ? refundingList : refundList;
    this.loading = true;
    const res: any = await url({
      timeRange: this.value,
      status: this.statusValue,
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      keyword: this.keyword,
      companyId: 1
    });
    if (res.data.code === 100) {
      if (this.editableTabsValue === '1') {
        this.orderList = [...this.orderList, ...res.data.data.list];
        this.orderList.forEach((ele, key, arr) => {
          if (arr[key].applyType === 3) {
            if (arr[key].status === 2) {
              this.$set(arr[key], 'statusStr', '申请失败');
            } else if (arr[key].status === 6) {
              this.$set(arr[key], 'statusStr', '已完成');
            } else if (arr[key].status === 7) {
              this.$set(arr[key], 'statusStr', '已取消');
            } else {
              this.$set(arr[key], 'statusStr', '处理中');
            }
          } else if (arr[key].status === 2) {
            this.$set(arr[key], 'statusStr', '申请失败');
          } else if (arr[key].status === 3) {
            this.$set(arr[key], 'statusStr', '已完成');
          } else if (arr[key].status === 7) {
            this.$set(arr[key], 'statusStr', '已取消');
          } else {
            this.$set(arr[key], 'statusStr', '处理中');
          }
        });
      } else {
        getDataRefund({
          refundingNum: res.data.data.total,
          equip: anchor ? anchor.equip : 4,
          version: anchor ? anchor.version : '',
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          model: anchor ? anchor.model : '',
          equipVersion: anchor ? anchor.equipVersion : '',
          equipMeid: anchor ? anchor.equipMeid : '',
          eventNo: '3.2.2.2.0.0.1',
          companyId: 1
        });
        this.orderList = res.data.data.list;
      }
      this.totalnumber = res.data.data.total;
      this.isNodata = this.orderList.length === 0;
      if (this.editableTabsValue === '1') {
        this.loadProductLinks(this.orderList);
      }
    } else {
      this.$message.error(res.data.message);
    }
    this.loading = false;
  }

  // 售后列表仅返回规格 ID，通过对应订单商品补齐跳转所需的商品 ID。
  private async loadProductLinks(items: any[]) {
    const requests = new Map<string, Promise<any>>();
    await Promise.all(items.map(async (item) => {
      if (item.productId) return;
      const key = String(item.productPriceId || item.id);
      if (!requests.has(key)) {
        requests.set(key, refundDetail({ refundId: item.id }));
      }
      try {
        const res: any = await requests.get(key);
        const detail = res.data.code === 100 && res.data.data.mallOrderDetail;
        if (detail && detail.productId) {
          this.$set(item, 'productId', detail.productId);
        } else {
          this.$set(item, 'productLinkError', true);
        }
      } catch (error) {
        this.$set(item, 'productLinkError', true);
      }
    }));
  }

  // 去付款
  async goPay(id: string) {
    this.$router.push(`/payment?id=${id}`);
  }

  goRecord() {
    this.$router.push('/exchange-list?status=0');
  }

  search() {
    const anchor = readCookie('anchor');
    this.pageSize = 10;
    this.pageNo = 1;
    getRefundSearch({
      refundingNum: '',
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: '3.2.2.1.0.0.1',
      companyId: 1
    });
    this.getOrderList();
  }

  private applydetails(id: string) {
    this.$router.push(`/exchange-details?id=${id}`);
  }

  // 订单详情
  goOrderDetails(id: number) {
    this.$router.push(`/order-details?id=${id}`);
  }

  handleSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.getOrderList();
    window.scrollTo(0, 0);
  }

  handleCurrentChange(pageNo: number) {
    this.pageNo = pageNo;
    this.getOrderList();
    window.scrollTo(0, 0);
  }
}
